import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { PostponeSlaPayload } from '../types';
import { LEAD_DETAILS } from './constants';

const usePostponeSla = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: PostponeSlaPayload }) => {
        const { lead_id, ...body } = payload;
        return req({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/leads/${lead_id}/postpone-sla/`,
            method: 'POST',
            body: JSON.stringify(body)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [LEAD_DETAILS] });
            setNotification({ message: 'SLA postponed' });
            onSuccess && onSuccess();
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default usePostponeSla;
